// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import type ReceiverCast from 'chromecast-caf-receiver';

declare const cast: typeof ReceiverCast;

export default cast || {};
